import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { NgxTimelineItem, NgxTimelineItemPosition, supportedLanguageCodes } from '@frxjs/ngx-timeline';
import { BehaviorSubject } from 'rxjs';
import { CustomNgxTimelineEvent } from 'src/app/modules/admin/profile-management/profile-detail/activity-tab/custom-event.model';
import { CustomNgxTimelineItem } from '../custom-timeline-model';

@Component({
  selector: 'app-custom-timeline-event',
  templateUrl: './custom-timeline-event.component.html',
  styleUrls: ['./custom-timeline-event.component.scss']
})
export class CustomTimelineEventComponent {


  /**
   * Event to be displayed
   */
  @Input() event: CustomNgxTimelineItem;
  /**
   * Event position respect to the vertical line (LEFT or RIGHT)
   */
  @Input() colSidePosition: NgxTimelineItemPosition;
  /**
   * Language code used to format the dates
   */
  @Input() langCode?: string;
  /**
   * Inner custom template used to display the event detail
   */
  @Input() innerEventCustomTemplate?: TemplateRef<any>;
  /**
   * Boolean used to enable or disable the animations
   */
  @Input() enableAnimation = true;
  /**
   * Output click event emitter
   */
  @Output() clickEmitter: BehaviorSubject<NgxTimelineItem> = new BehaviorSubject(null);

  ngxTimelineItemPosition = NgxTimelineItemPosition;

  private readonly monthAbbr = 'MMM';
  private readonly dayFormat = 'dd';

  constructor() { }

  getDateObj(): any {
    let day;
    let month;
    let year;
    const dateTimestamp = this.event?.eventInfo?.timestamp;
    if (dateTimestamp) {
      const timestamp = new Date(dateTimestamp);
      const langCode = this.getLangCode();
      month = new DatePipe(langCode).transform(timestamp, this.monthAbbr);
      day = new DatePipe(langCode).transform(timestamp, this.dayFormat);
      year = timestamp.getFullYear();
    }

    return { day, month, year };
  }

  protected getLangCode(): string {
    return this.langCode && supportedLanguageCodes.includes(this.langCode) ? this.langCode : supportedLanguageCodes[0];
  }

  getBackGroundColor(eventInfo: CustomNgxTimelineEvent) {
    if (eventInfo) {
      if (eventInfo.task)
        return '#cce5ff'; //Color task
      else if(eventInfo.activityLog.activityType.toLocaleLowerCase() == "cfcall"){
        return '#86ffa2';
      }
      else {
        if(eventInfo.activityLog.subObjName == "ExternalEmail" || eventInfo.activityLog.subObjName == "ExternalCall"
        || eventInfo.activityLog.subObjName == "ExternalOther"){
          return '#f7f7f7';
        }
        else{
          switch (eventInfo.activityLog.action.toLowerCase()) {
            case 'submit':
            case 'click':
            case 'read':
            case 'unsubscribed':
              return '#f7f7f7';
            case 'reply':
            case 'replydetail':
              return '#d3ffc6';
            case 'send':
            case 'scansend':
            case 'call':
            case 'amdcall':
            case 'leavemessage':
            case 'bounce':
              return '#feffce';
            case 'inboundcall':
              return 'rgb(217 253 217)';
            case 'convert':
              return '#93DF93'
            case 'outbound':
              return '#FFE4C4';
            case 'inbound':
              return '#FFEFDB';
            case 'comment':
              return '#a6f1fb';
            default:
              return '#ffffff';
          }
        } 
      }
    }
  }

  arrowBlock(eventInfo: CustomNgxTimelineEvent) {
    if (eventInfo)
      return `0.5rem solid ${this.getBackGroundColor(eventInfo)}`;
  }

  backGroundColor(eventInfo: CustomNgxTimelineEvent) {
    if (eventInfo)
      return { 'background-color': `${this.getBackGroundColor(eventInfo)}` };
  }
}
